export default {
  login: {
    title: 'เข้าสู่ระบบ',
    username: 'ชื่อผู้ใช้',
    phone: 'หมายเลขโทรศัพท์',
    phoneCode: 'รหัส',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    captcha: 'รหัสยืนยัน',
    loading: 'กำลังโหลด...',
    rememberMe: 'จดจำฉัน',
    forgotPassword: 'ลืมรหัสผ่าน?',
    loginButton: 'เข้าสู่ระบบ',
    contactUs: 'ติดต่อเรา？',
    noAccount: 'ยังไม่มีบัญชี?',
    registerNow: 'สมัครสมาชิก',
    or: 'หรือ',
    orSignInWith: 'หรือเข้าสู่ระบบด้วย',
    methodUsername: 'ชื่อผู้ใช้',
    methodPhone: 'โทรศัพท์',
    methodEmail: 'อีเมล',
    usernameRequired: 'กรุณากรอกชื่อผู้ใช้',
    phoneRequired: 'กรุณากรอกหมายเลขโทรศัพท์',
    emailRequired: 'กรุณากรอกอีเมล',
    passwordRequired: 'กรุณากรอกรหัสผ่าน',
    captchaRequired: 'กรุณากรอกรหัสยืนยัน',
    resetPassword: 'รีเซ็ตรหัสผ่าน',
    resetStep1Hint: 'กรอกหมายเลขโทรศัพท์หรืออีเมลเพื่อรับรหัสยืนยัน',
    useEmailInstead: 'ใช้อีเมลแทน',
    usePhoneInstead: 'ใช้โทรศัพท์แทน',
    sendCode: 'ส่งรหัส',
    resetStep2Hint: 'รหัสยืนยันถูกส่งไปที่',
    verificationCode: 'รหัสยืนยัน',
    verificationCodeRequired: 'กรุณากรอกรหัสยืนยัน',
    resendIn: 'ส่งอีกครั้งใน',
    resendCode: 'ส่งรหัสอีกครั้ง',
    verify: 'ยืนยัน',
    resetStep3Hint: 'ตั้งรหัสผ่านใหม่ของคุณ',
    newPassword: 'รหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
    confirmPasswordRequired: 'กรุณายืนยันรหัสผ่าน',
    passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
    resetPasswordBtn: 'รีเซ็ตรหัสผ่าน',
    back: 'กลับ',
    // Format validation
    emailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
    // Toast messages
    loginSuccess: 'เข้าสู่ระบบสำเร็จ',
    loginFailed: 'เข้าสู่ระบบไม่สำเร็จ',
    signInWithGoogle: 'เข้าสู่ระบบด้วย Google+',
    codeSent: 'ส่งรหัสยืนยันแล้ว',
    sendCodeFailed: 'ส่งรหัสไม่สำเร็จ',
    invalidCode: 'รหัสยืนยันไม่ถูกต้อง',
    resetSuccess: 'ตั้งรหัสผ่านใหม่สำเร็จ',
    resetFailed: 'ตั้งรหัสผ่านใหม่ไม่สำเร็จ'
  }
};
